import React, { FunctionComponent } from 'react';
import styles from '../../../../styles/VideoBlock.module.scss';
import { VideoBlockModel } from '../../../../services/content/articleBody/models/VideoBlockModel';
import { VideoModel } from '../../../../services/content/video/models/VideoModel';

type Props = {
    videoBlock: VideoBlockModel;
};

export const VideoBlock: FunctionComponent<Props> = ({ videoBlock }) => {
    const blockContent: VideoModel = videoBlock.data.content;

    if (blockContent && blockContent.id) {
        return (
            <div className={`${styles.container} pb-4 pt-4 w-100 text-center`}>
                <iframe
                    className={`${styles.iframe}`}
                    src={`${process.env.NEXT_PUBLIC_WEBSITE_URL}/embedVideo/${blockContent.id}?autoplay=false`}></iframe>
            </div>
        );
    }

    return null;
};
